// TanStack Query cache keys for the admin dashboard slice. Recent trades
// is keyed by limit so the home screen (10 rows) does not collide with
// future widgets that may sample larger windows.
export const adminDashboardKeys = {
  all: ["admin", "dashboard"] as const,
  snapshot: () => ["admin", "dashboard", "snapshot"] as const,
  recentTrades: (limit: number) =>
    ["admin", "dashboard", "recent-trades", limit] as const,
  topPlayers: () => ["admin", "dashboard", "top-players"] as const,
};
